import React, { useCallback, useMemo, useState } from "react"
import { Button } from "@chakra-ui/react"

import Icon from "@app/components/Icon"
import { useWishlistContext } from "@app/providers/wishlist"

type Props = {
  product: any
}

const ProductWishlist: React.FC<Props> = ({ product }) => {
  const { fetched, isInWishlist, addToWishlist, removeFromWishlist } = useWishlistContext()
  const [adding, setAdding] = useState(false)

  const inWishlist = useMemo(() => isInWishlist(product), [isInWishlist, product])
  const label = useMemo(() => (inWishlist ? "Remove from Wishlist" : "Add to Wishlist"), [inWishlist])

  const handleClick = useCallback(async () => {
    if (inWishlist) {
      await removeFromWishlist(product)
    } else {
      setAdding(true)
      await addToWishlist(product)
      setAdding(false)
    }
  }, [addToWishlist, inWishlist, product, removeFromWishlist])

  return fetched ? (
    <Button
      variant="fillRainbowLoader"
      aria-label={label}
      title={label}
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      onClick={handleClick}
      w="48px"
      h="48px"
      minWidth="48px"
      borderRadius="full"
      border="1px solid"
      borderColor="brand.black"
      backgroundColor="brand.white"
      sx={{
        "&:hover > div": {
          "@media (hover: hover) and (pointer: fine)": {
            color: "transparent",
          },
        },
      }}
      p={0}
      // isActive={adding}
    >
      <Icon
        name="heart"
        className={adding ? "rotate-full" : ""}
        color={inWishlist ? "preset.worldRed" : adding ? "transparent" : "brand.black"}
        fill={inWishlist ? "preset.worldRed" : "brand.white"}
        width={{ base: "21px", sm: "22px", md: "21px" }}
        height={{ base: "21px", sm: "22px", md: "21px" }}
        sx={{
          "@media (hover: hover) and (pointer: fine)": {
            _hover: {
              fill: inWishlist ? "preset.worldRed" : "brand.white",
              color: inWishlist ? "preset.worldRed" : "brand.white",
            },
          },
        }}
        p={0}
      />
    </Button>
  ) : null
}

export default React.memo(ProductWishlist)
